import { IOperation, ISetting } from '@/models/IFunctionality';
import { IRecord, IRecords } from '@/models/IRecord';
import FunctionalityRecordDetail from '../records/FunctionalityRecordDetail';

export interface IFunctionalitySettingsDetail {
  setting: ISetting;
  operations: IOperation[];
  records: IRecords;
}

export function FunctionalitySettingsDetail({
  setting,
  operations,
  records
}: IFunctionalitySettingsDetail) {
  let recordName;
  const outputRecord = () => {
    if (!records) return null;
    const operation = operations.find(
      operation => operation.name === setting.operation.$ref.split('/').pop()
    );
    if (!operation || !operation.output) return null;
    recordName = operation.output.$ref.split('/').pop();
    if (!recordName) return null;

    const record = records[recordName];
    if (!record) return null;

    record.doc = operation.doc;
    return record;
  };

  const record = outputRecord();
  if (!record) return <></>;

  return (
    <div data-testid="operation-output-json">
      <FunctionalityRecordDetail
        name={recordName}
        record={record as IRecord}
        records={records}
      />
    </div>
  );
}
